export default {
  FlightStops__BADGE_FLIGHT_STOPS: (data) =>
    `${data.STOPS === 0 ? "Nonstop" : data.STOPS === 1 ? "1 Stop" : `${data.STOPS} Stops`}`, // NOSONAR
  FlightStops__FLIGHT_STOPS_ARIA_LABEL: (data) =>
    `${data.STOPS === 0 ? "Nonstop." : data.STOPS === 1 ? "1 Stop." : `${data.STOPS} Stops.`}`,
};
